export const getFileExtension = (givenUrl) => {

    if(!givenUrl || givenUrl?.length < 1){
        return '';
    }

    const cleanUrl = givenUrl.split("?")[0];
    const extension = cleanUrl.split(".").pop().toLowerCase();

    return extension;
};